import { render, staticRenderFns } from "./houseCarousel.vue?vue&type=template&id=6b330746&"
import script from "./houseCarousel.vue?vue&type=script&lang=js&"
export * from "./houseCarousel.vue?vue&type=script&lang=js&"
import style0 from "./houseCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\TeamCity\\buildAgent\\work\\d66fd695757ba5a4\\src\\SABONyproduktion.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6b330746', component.options)
    } else {
      api.reload('6b330746', component.options)
    }
    module.hot.accept("./houseCarousel.vue?vue&type=template&id=6b330746&", function () {
      api.rerender('6b330746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/houseModel/components/houseCarousel.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./assets/vue/houseModel/components/houseCarousel.vue
// module id = 470
// module chunks = 0